import { Component, Input, OnDestroy } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip'; 
import { DashboardTileCountViewModel } from '@modules/api/dashboard-tile-count-view-model.generated';
import { GetDashboardTileEmailService } from '@modules/api/get-dashboard-tile-email.service.generated';
import { ExtendedDashboardTileViewModel } from '@modules/dashboard/models/extended-dashboard-tile-view-model';
import { CopyToClipboardService } from '@modules/common/services/copy-to-clipboard.service';
import { SnackbarService } from '@modules/common/services/snackbar.service';
import { DashboardDetailGridModalComponent } from '@modules/dashboard/components/dashboard-detail-grid-modal/dashboard-detail-grid-modal.component';
import { DashboardDetailGridModalArgs } from '@modules/dashboard/models/dashboard-detail-grid-modal-args';
import { GetDashboardTileDataService } from '@modules/api/get-dashboard-tile-data.service.generated';
import { MatDialog } from '@angular/material/dialog';


@Component({
    selector: 'app-dashboard-actions',
    templateUrl: './dashboard-actions.component.html',
    styleUrls: ['./dashboard-actions.component.scss']
})
export class DashboardActionsComponent implements OnDestroy {
    public toolTipStatus: string = "Copy Email Address";
    public delayValue: number = 0;
    private _timer?: number;
    @Input()
    public tile?: ExtendedDashboardTileViewModel;

    @Input()
    public item?: DashboardTileCountViewModel;

    @Input()
    public divider?: boolean;

    constructor(
        private readonly _getDashboardTileDataService: GetDashboardTileDataService,
        private readonly _getDashboardTileEmailService: GetDashboardTileEmailService,
        private readonly _snackbarService: SnackbarService,
        private readonly _copyToClipboardService: CopyToClipboardService,
        private readonly _dialogRef: MatDialog
    ) { 
    }

    public getDashboardTileEmail(tooltip: MatTooltip): void {
        if (this.tile) {
            this._getDashboardTileEmailService.getDashboardTileEmail({
                dashboardTileId: this.tile.dashboardTileId,
                filterValue: this.item && this.item.itemName,
            }).subscribe(result => {
                if (result && result.emailAddressList && result.emailAddressList.length) {
                    this._copyToClipboardService.copyToClipboard(result.emailAddressList.join(';'));
                    this._snackbarService.open({
                        message: result.emailAddressList.length + ' EMAIL ADDRESSES COPIED TO CLIPBOARD'
                    });
                    clearTimeout(this._timer);
                    this.toolTipStatus = "Copied!";
                    tooltip.show();
                    this.delayValue = 5000;
                    this._timer = setTimeout(() => {
                        this.delayValue = 0;
                        this.toolTipStatus = "Copy Email Address";
                        tooltip.hide(0);
                    }, 5000);
                } else {
                    this._snackbarService.open({
                        message: 'NO EMAIL ADDRESSES FOUND'
                    });
                }
            });
        }
    }

    public showDetail(): void {
        if (this.tile) {
            this._getDashboardTileDataService.getDashboardTileData({
                dashboardTileId: this.tile.dashboardTileId,
                filterValue: this.item && this.item.itemName,
            }).subscribe((tileDataResult) => {
                if (tileDataResult.data && tileDataResult.headers) {
                    this._dialogRef.open<DashboardDetailGridModalComponent, DashboardDetailGridModalArgs>(DashboardDetailGridModalComponent, {
                        width: "65%",
                        height: "70%",
                        data: {
                            dashboardTile: this.tile!,
                            dashboardTileItem: this.item,
                            data: tileDataResult.data,
                            headers: tileDataResult.headers,
                        }
                    });
                }
            });
        }
    }

    public ngOnDestroy(): void {
        if(this._timer){
            clearTimeout(this._timer);
        }
    }
}
